// Tailored generator configuration per creation type.
export const TOOLS = {
  text_to_image: {
    service: "text_to_image",
    title: "Create an Image",
    subtitle: "Describe what you want and let AI bring it to life.",
    icon: "Sparkles",
    prompt: { label: "What do you want to create?", placeholder: "Describe the image you want to create...", required: true, rows: 4 },
    aspectRatios: ["1:1", "4:5", "16:9", "9:16", "3:4"],
    quantities: [1, 2, 4],
    upload: null,
    fields: [],
  },
  image_to_image: {
    service: "image_to_image",
    title: "Image to Image",
    subtitle: "Upload an image and transform it with a prompt.",
    icon: "Images",
    prompt: { label: "Transformation", placeholder: "Transform this into a luxury studio advertisement...", required: true, rows: 3 },
    aspectRatios: ["1:1", "4:5", "16:9", "9:16"],
    quantities: [1, 2],
    upload: { label: "Source image", required: true },
    fields: [],
  },
  image_edit: {
    service: "image_edit",
    title: "Edit an Image",
    subtitle: "Upload an image and describe your edit.",
    icon: "Wand2",
    prompt: { label: "Edit instruction", placeholder: "Replace the background with a marble studio...", required: true, rows: 3 },
    aspectRatios: ["1:1", "4:5", "16:9"],
    quantities: [1],
    upload: { label: "Image to edit", required: true },
    fields: [],
  },
  product_ad: {
    service: "product_ad",
    title: "Product Ad",
    subtitle: "Turn your product photo into a professional advertisement.",
    icon: "ShoppingBag",
    prompt: { label: "Describe your ad", placeholder: "A luxury studio ad for AuraGlow serum on marble with soft light, tagline 'Glow that lasts'...", required: true, rows: 4 },
    aspectRatios: ["1:1", "4:5", "16:9", "9:16"],
    quantities: [1, 2],
    upload: { label: "Product image", required: true },
    fields: [],
  },
  restaurant_ad: {
    service: "restaurant_ad",
    title: "Restaurant Ad",
    subtitle: "Create mouth-watering food & restaurant creatives.",
    icon: "Utensils",
    prompt: null,
    aspectRatios: ["1:1", "4:5", "9:16", "16:9"],
    quantities: [1, 2],
    upload: { label: "Dish image", required: true },
    logoUpload: true,
    fields: [
      { key: "restaurant_name", label: "Restaurant name", placeholder: "Saffron Kitchen", required: true },
      { key: "dish_name", label: "Dish name", placeholder: "Butter Chicken", required: true },
      { key: "price", label: "Price", placeholder: "₹349" },
      { key: "offer", label: "Offer", placeholder: "Buy 1 Get 1" },
      { key: "description", label: "Description", placeholder: "Rich, creamy & authentic" },
      { key: "address", label: "Address", placeholder: "MG Road, Bengaluru" },
      { key: "phone", label: "Phone", placeholder: "+91 98765 43210" },
      { key: "website", label: "Website", placeholder: "saffron.com" },
      { key: "cta", label: "Call to action", placeholder: "Order Now" },
      { key: "theme", label: "Theme", type: "select", options: ["Modern", "Luxury", "Cafe", "Fast Food", "Indian", "Street Food", "Family Restaurant", "Festive"] },
    ],
  },
  instagram_post: {
    service: "instagram_post",
    title: "Social Post",
    subtitle: "Create Instagram-ready content in seconds.",
    icon: "Share2",
    prompt: { label: "Describe your post", placeholder: "Instagram post about summer skincare, minimal aesthetic, headline 'Glow all summer'...", required: true, rows: 4 },
    aspectRatios: ["1:1", "4:5", "9:16"],
    quantities: [1, 2],
    upload: { label: "Image (optional)", required: false },
    fields: [],
  },
  youtube_thumbnail: {
    service: "youtube_thumbnail",
    title: "YouTube Thumbnail",
    subtitle: "Design high-CTR thumbnails that get the click.",
    icon: "Youtube",
    prompt: { label: "Describe your thumbnail", placeholder: "Bold thumbnail for '30 days fitness challenge', dramatic mood, overlay text '30 DAYS!'...", required: true, rows: 4 },
    aspectRatios: ["16:9"],
    quantities: [1, 2, 4],
    upload: { label: "Background image (optional)", required: false },
    fields: [],
  },
  background_generation: {
    service: "background_generation",
    title: "Background Generator",
    subtitle: "Keep your subject, replace the background.",
    icon: "Image",
    prompt: { label: "Describe the background", placeholder: "Luxury marble studio, soft light...", required: true, rows: 3 },
    aspectRatios: ["1:1", "4:5", "16:9", "9:16"],
    quantities: [1, 2],
    upload: { label: "Subject / product", required: true },
    fields: [],
  },
  background_removal: {
    service: "background_removal",
    title: "Background Removal",
    subtitle: "Get a clean transparent cutout instantly.",
    icon: "Eraser",
    prompt: null,
    aspectRatios: ["1:1"],
    quantities: [1],
    upload: { label: "Upload image", required: true },
    fields: [],
    simple: true,
  },
  upscaling: {
    service: "upscaling",
    title: "Upscaler",
    subtitle: "Increase resolution up to 4x with no quality loss.",
    icon: "Maximize2",
    prompt: null,
    aspectRatios: ["1:1"],
    quantities: [1],
    upload: { label: "Upload image", required: true },
    fields: [
      { key: "scale", label: "Scale", type: "select", options: ["2x", "4x"] },
    ],
    simple: true,
  },
  variation: {
    service: "variation",
    title: "Variations",
    subtitle: "Generate alternative versions of an image.",
    icon: "Copy",
    prompt: { label: "Guidance (optional)", placeholder: "Keep the same style...", required: false, rows: 2 },
    aspectRatios: ["1:1", "4:5", "16:9"],
    quantities: [2, 4],
    upload: { label: "Source image", required: true },
    fields: [],
  },
  inpainting: {
    service: "inpainting",
    title: "Inpainting",
    subtitle: "Mask an area and replace it with AI.",
    icon: "Brush",
    prompt: { label: "What to replace", placeholder: "Replace the chair with a modern wooden chair...", required: true, rows: 3 },
    aspectRatios: ["1:1", "4:5", "16:9"],
    quantities: [1],
    upload: { label: "Image", required: true },
    fields: [],
  },
  // ---------- Video generation ----------
  text_to_video: {
    service: "text_to_video",
    title: "Text to Video",
    subtitle: "Generate a video from a text prompt.",
    icon: "Video",
    prompt: { label: "Describe your video", placeholder: "A slow cinematic pan over a foggy mountain range at sunrise, cinematic lighting...", required: true, rows: 4 },
    aspectRatios: ["16:9", "9:16", "1:1"],
    quantities: [1],
    upload: null,
    fields: [],
    durations: [10, 20, 30],
    media: "video",
  },
  image_to_video: {
    service: "image_to_video",
    title: "Image to Video",
    subtitle: "Animate an uploaded image into a video.",
    icon: "FilmIcon",
    prompt: { label: "Motion & style", placeholder: "Slow zoom-in, camera drifts left, cinematic style, warm color grade...", required: true, rows: 4 },
    aspectRatios: ["16:9", "9:16", "1:1"],
    quantities: [1],
    upload: { label: "Source image", required: true },
    fields: [],
    durations: [10, 20, 30],
    media: "video",
  },
  video_extend: {
    service: "video_extend",
    title: "AI Video Extend",
    subtitle: "Extend an existing video with new coherent frames.",
    icon: "MoveRight",
    prompt: { label: "How should it continue?", placeholder: "Continue with the same subject walking forward, same camera style...", required: true, rows: 4 },
    aspectRatios: ["16:9", "9:16", "1:1"],
    quantities: [1],
    upload: { label: "Source video", required: true, accept: "video/*" },
    fields: [],
    durations: [10, 20, 30],
    media: "video",
  },
};

export const IMAGE_TOOLS = ["text_to_image", "product_ad", "restaurant_ad", "instagram_post", "youtube_thumbnail", "image_edit", "image_to_image", "background_removal", "background_generation", "upscaling", "variation", "inpainting"];
export const VIDEO_TOOLS = ["text_to_video", "image_to_video", "video_extend"];
export const CORE_TOOLS = ["text_to_image", "product_ad", "restaurant_ad", "instagram_post", "youtube_thumbnail", "image_edit"];
export const MORE_TOOLS = ["image_to_image", "background_removal", "background_generation", "upscaling", "variation", "inpainting"];

export function buildPrompt(cfg, values) {
  if (cfg.prompt) return values.prompt || "";
  // Build an internal prompt from structured fields (user never writes prompts for ads).
  const parts = [];
  cfg.fields.forEach((f) => {
    if (values[f.key]) parts.push(`${f.label}: ${values[f.key]}`);
  });
  return `${cfg.title} — ${parts.join(", ")}`;
}
